import React from "react";
import { Container } from "@mui/material";
import OffreTemplate from "../components/OffreTemplate";
import SEO from "../components/SEO";
import SeoInternalLinks from "../components/SeoInternalLinks";
import exampleApp1 from "../assets/images/projets/lecozenAdmin1.png";
import exampleApp2 from "../assets/images/projets/hexagoneAdmin1.png";
import imgGestion1 from "../assets/images/imgGestion1.png";
import imgGestion2 from "../assets/images/imgGestion2.png";
import imgGestion3 from "../assets/images/imgGestion3.png";
import imgGestion4 from "../assets/images/imgGestion4.png";

export default function OffreWebAppPage() {
  return (
    <>
      <SEO
        title="Logiciel métier sur mesure pour PME | DigiBuddy"
        description="Développement de logiciel métier et d'application web sur mesure : automatisation des processus, tableaux de bord et intégrations avec vos outils."
        keywords="logiciel métier sur mesure, développement logiciel sur mesure, application web métier, automatisation process entreprise, outil interne PME, CRM sur mesure"
        url="https://www.digibuddy.fr/logiciel-metier-sur-mesure"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Logiciels SaaS & Applications Web sur Mesure",
          description:
            "Logiciels SaaS, CRM, ERP, dashboards sur mesure. Applications web qui automatisent vos processus.",
          provider: {
            "@type": "Organization",
            name: "DigiBuddy",
          },
          areaServed: "FR",
          serviceType: "Développement logiciel",
          offers: {
            "@type": "Offer",
            price: "À partir de 8000€",
            priceCurrency: "EUR",
          },
        }}
      />
      <OffreTemplate
        title="Logiciels qui automatisent votre business"
        intro="<b>Transformez vos processus manuels en outils digitaux<br>qui font gagner du temps à vos équipes.</b><br><br>Vos équipes se concentrent sur l'essentiel pendant que nos logiciels gèrent le reste."
        bannerImage="/images/banner-logiciel.jpg"
        url="https://www.digibuddy.fr/logiciel-metier-sur-mesure"
        sections={[
          {
            title: "Automatisez vos tâches répétitives",
            subtitle: "Vos équipes gagnent 2h par jour",
            paragraph:
              "Nous créons des logiciels qui automatisent vos processus manuels et répétitifs. Vos équipes se concentrent sur ce qui compte vraiment pour votre business.",
            bullets: [
              "CRM personnalisé pour la gestion client",
              "ERP pour piloter votre entreprise",
              "Dashboards temps réel pour prendre les bonnes décisions",
              "Applications spécialisées par secteur d'activité",
            ],
            imageSrc: imgGestion1,
          },
          {
            title: "Interface intuitive et moderne",
            subtitle: "Vos équipes adoptent facilement",
            paragraph:
              "Un logiciel doit être facile à utiliser pour être adopté par vos équipes. Nous créons des interfaces claires, rapides et agréables qui facilitent le travail quotidien.",
            bullets: [
              "Design moderne et responsive (PC, tablette, mobile)",
              "Navigation intuitive et workflows optimisés",
              "Tableaux de bord personnalisables",
              "Interface adaptée aux habitudes de vos équipes",
            ],
            imageSrc: imgGestion2,
          },
          {
            title: "Sécurité et fiabilité",
            subtitle: "Vos données sont protégées",
            paragraph:
              "La sécurité de vos données est notre priorité. Nous mettons en place des architectures robustes avec sauvegardes automatiques et monitoring continu.",
            bullets: [
              "Hébergement sécurisé en France",
              "Sauvegardes automatiques quotidiennes",
              "Chiffrement des données sensibles",
              "Monitoring et alertes en temps réel",
            ],
            imageSrc: imgGestion3,
          },
          {
            title: "Intégration avec vos outils existants",
            subtitle: "Tout fonctionne ensemble",
            paragraph:
              "Vos nouveaux logiciels s'intègrent parfaitement avec vos systèmes existants. Nous développons des connecteurs pour synchroniser vos données et automatiser vos processus.",
            bullets: [
              "Connexion avec vos logiciels existants",
              "Synchronisation automatique des données",
              "API pour intégrer vos outils",
              "Automatisation des tâches répétitives",
            ],
            imageSrc: imgGestion4,
          },
        ]}
        galleryImages={[exampleApp1, exampleApp2]}
      />
      <Container sx={{ py: 2 }} style={{ maxWidth: "800px" }}>
        <SeoInternalLinks
          title="À lire aussi"
          links={[
            { to: "/creation-site-web-sur-mesure", label: "Création de site web sur mesure" },
            { to: "/combien-coute-site-web-sur-mesure", label: "Combien coûte un site web sur mesure ?" },
            { to: "/freelance-ou-agence-pour-creer-son-site", label: "Freelance ou agence ?" },
            { to: "/", label: "Accueil" },
          ]}
        />
      </Container>
    </>
  );
}
